import axios from "axios";

// ----------------------------------------------------------------------
const HOST_API = process.env.REACT_APP_HOST_API_KEY || "";

export const axiosInstance = axios.create({
  baseURL: HOST_API,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  },
});

export function setApiToken(token: string) {
  axiosInstance.defaults.headers["Authorization"] = `Bearer ${token}`;
}

export default axiosInstance;
